export const LEAD_CAROUSEL_PLACEMENT = {
    TOP: 'SERP_HITS_TOP_PLACEMENT',
    MIDDLE: 'SERP_HITS_MIDDLE_PLACEMENT',
    BOTTOM: 'SERP_HITS_BOTTOM_PLACEMENT',
    HIDE: 'SERP_HITS_HIDE'
};

export const EdapCarouselPlacementsMap = {
    SERP_HITS_TOP_PLACEMENT: 'top',
    SERP_HITS_MIDDLE_PLACEMENT: 'middle',
    SERP_HITS_BOTTOM_PLACEMENT: 'bottom'
};

export const SERP_PREVIOUSLY_VIEWED_CAROUSEL =
    'SERP_PREVIOUSLY_VIEWED_CAROUSEL';
